import { createSlice } from '@reduxjs/toolkit';
import { NavNodeStatus, SliceNames } from '../../services/enums';
import { IHazelAction } from '../app/slice';

export interface IExperience extends IHazelAction {
  experienceId: string | null;
  requestedNavNodeId: string | null;
  status: NavNodeStatus;
}

const initialState: IExperience = {
  experienceId: null,
  status: NavNodeStatus.Start,
  requestedNavNodeId: null,
};

const experienceSlice = createSlice({
  name: SliceNames.experience,
  initialState,
  reducers: {},
});

export const experienceReducer = experienceSlice.reducer;

export { initialState as experienceInitialState };
// export const {} = experienceSlice.actions;
